import { selectorFamily } from "recoil";

import { evaluateTextTemplating } from "./utils";

/**
 * Compute text templating, this selector avoid computing text templating too many times
 * dues to components renders.
 */
export const textTemplatingEvaluateSelector = selectorFamily<
  string,
  {
    text: string;
    objects: { [key: string]: any };
  }
>({
  key: "TextTemplatingEvaluateSelector",
  get:
    ({ text, objects }) =>
    () => {
      return evaluateTextTemplating(text, objects);
    },
});
